import React from 'react';
import { Alert, AlertTitle } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledAlert = styled(Alert, {
    shouldForwardProp: (prop) => prop !== 'compact',
})(({ theme, compact }) => ({
    fontSize: compact ? '0.7rem' : '0.8125rem',
    padding: compact ? '2px 8px' : '10px 12px',
    borderRadius: 6,
    border: '1px solid',
    alignItems: 'center',

    minHeight: compact ? 'auto' : undefined,

    '&.MuiAlert-standardError': {
        backgroundColor: '#ffebee',
        borderColor: '#ef5350',
        color: '#c62828',
    },

    '&.MuiAlert-standardWarning': {
        backgroundColor: '#fff3e0',
        borderColor: '#ff9800',
        color: '#e65100',
    },

    '&.MuiAlert-standardInfo': {
        backgroundColor: '#e3f2fd',
        borderColor: '#42a5f5',
        color: '#01579b',
    },

    '&.MuiAlert-standardSuccess': {
        backgroundColor: '#e8f5e9',
        borderColor: '#4caf50',
        color: '#2e7d32',
    },

    '& .MuiAlert-icon': {
        padding: 0,
        marginRight: compact ? '4px' : '10px',
        opacity: 1,
        alignItems: 'center',
        display: 'flex',

        '& svg': {
            fontSize: compact ? 14 : 18,
        },
    },

    '& .MuiAlert-message': {
        padding: 0,
        display: 'flex',
        alignItems: 'center',
        overflow: 'visible',
        lineHeight: compact ? 1.1 : 1.4,
    },

    '& .MuiAlert-action': {
        padding: 0,
        paddingLeft: compact ? '4px' : '8px',
        marginRight: 0,
        alignItems: 'center',
        display: 'flex',
    },

    '& .MuiAlertTitle-root': {
        marginTop: 0,
        marginBottom: compact ? '2px' : '4px',
        fontSize: compact ? '0.75rem' : '0.875rem',
        fontWeight: 600,
    },
}));

const LsAlert = ({
    severity = 'info',
    title,
    children,
    compact = false,
    ...props
}) => {
    return (
        <StyledAlert
            severity={severity}
            compact={compact}
            {...props}
        >
            {title && <AlertTitle>{title}</AlertTitle>}
            {children}
        </StyledAlert>
    );
};

export default LsAlert;
